mainApp.directive('lookupPopup', function(){
    return {
        templateUrl: '/public/directives/lookupPopup.html',
        replace: true,
        scope: {
            options: '='
        },
        controller: function($scope, $timeout, $element, $state){
            $scope.$el = $($element[0].children[0]);
            $scope.$temp = $($element[0].children[1]);
            $scope.overPopup = false;

            $scope.$watch('options.params', function(){
                fetchData();
            });

            $scope.hidePopup = function() {
                $scope.overPopup = false;
            };

            $scope.showPopup = function() {
                $scope.overPopup = true;
            };

            $scope.goToSettings = function () {
                $state.go($scope.options.settingsState, $scope.options.settingsParams);
            };

            $scope.items = [];

            $scope.ready = false;

            function fetchData(){
                $scope.items = [];
                $scope.$el.hide();
                $scope.ready = false;

                if($scope.options.url && $scope.options.pos){
                    var params = $scope.options.params;

                    store.fetch({
                        path: $scope.options.url,
                        queryParams: $scope.options.params,
                        method: $scope.options.method || "GET",
                        success: function (data) {
                            if(!$scope.options.pos || !angular.equals($scope.options.params, params)){
                                $scope.$el.hide();
                                return;
                            }

                            if ($scope.options.process) {
                                $scope.items = null;
                                $scope.content = $scope.options.process(data);
                            }
                            else if($scope.options.items) {
                                $scope.contentHTML = null;

                                if(data && data.items){
                                    $scope.items = data.items;
                                    $scope.total = data.total;
                                }
                                else {
                                    $scope.items = [];
                                }
                            }

                            if ($scope.options.pos) {
                                var targetLeft = $scope.options.pos.x - ($scope.$temp.width()/2);
                                if (targetLeft < -50) {
                                    targetLeft = -50;
                                }
                                $scope.$el.css({
                                    top: $scope.options.pos.y,
                                    left: targetLeft
                                });

                                $scope.$el.show();

                                $scope.ready = true;
                            }
                            $scope.$digest();
                        }
                    });
                }

            }
        }
    };
});